import React from 'react';
import './ExpiredToken.css';

const ExpiredToken = ({ lastUpdatedBy }) => {
  return (
    <div className="expired-token-container">
      <div className="expired-token-content">
        <h2>This Link Has Already Been Used</h2>
        <p>
          Someone from your church has already used this link to update the information.
        </p>
        <p className="last-updated-by">
          <strong>{lastUpdatedBy}</strong> has made the latest update.
        </p>
        <p>If you need help or think this is an error, please contact our support team.</p>
        <div className="expired-token-action">
          <a href="mailto:support@example.com" className="contact-link">Contact Support</a>
        </div>
      </div>
    </div>
  );
};

export default ExpiredToken;
